import {User} from '/src/domain/shared/User';
import {ChallengeProtocolData} from "/src/domain/challenges/ChallengeProtocolData";
import {trimName} from "/src/domain/shared/trimName"

export const appealEmail = (challengeProtocol: ChallengeProtocolData, currentUser: User | undefined, email: string): void => {
    window.open(
        `mailto:${email}?subject=` +
        challengeProtocol.challenge.name +
        ' #' +
        currentUser?.id +
        ' ' +
        trimName(currentUser?.firstName, currentUser?.lastName),
        '_blank')
}